import { toast } from "react-toastify";

export const successToastify = (msg) => {
    toast.success(`${msg}`, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined
    });
};
export const errorToastify = (msg) => {
    toast.error(`${msg}`, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        progress: undefined
    });
};
